export default "__VITE_ASSET__DJXFB7yA__"